import { render, staticRenderFns } from "./UpdatePCN.vue?vue&type=template&id=37cc11e3"
import script from "./UpdatePCN.vue?vue&type=script&lang=js"
export * from "./UpdatePCN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports